import * as React from 'react';

function SvgLongTail(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 39 39" {...props}>
      <path d="M16.198 16.25V39H0V25.005l16.198-8.755zM39 0v39H19.5V0H39zm-6.5 16.25H26v6.6h6.5v-6.6zm0-9.75H26v6.6h6.5V6.5z" />
    </svg>
  );
}

export default SvgLongTail;
